import urls from 'DjangoUrls';
let {DjangoUrls} = urls;

function resolveUrl() {
    return function (name, ...rest) {
        return DjangoUrls[name](...rest);
    };
}

export default resolveUrl;